import { ADVERTISEMENT_TYPE } from '@constants/enums';
import { useLocale } from '@hooks/useLocale';

class AdvertisementUtil {
  public selectAdvertisement = (advertisementType: ADVERTISEMENT_TYPE): string => {
    const locale = useLocale();
    const isDP = locale === 'nl-NL';

    let advertisement = '';
    switch (advertisementType) {
      case ADVERTISEMENT_TYPE.ARTICLE:
        isDP
          ? (advertisement =
              '<ins class="adsbygoogle" style="display:block; text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-8656564782464834" data-ad-slot="8675886898"></ins><script> (adsbygoogle = window.adsbygoogle || []).push({});</script>')
          : (advertisement =
              '<ins class="adsbygoogle" style="display:block; text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-8656564782464834" data-ad-slot="1256631683"></ins><script> (adsbygoogle = window.adsbygoogle || []).push({});</script>');
        break;
      case ADVERTISEMENT_TYPE.SIDEBAR:
        isDP
          ? (advertisement =
              '<!-- Large rectangle side bar --><ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-8656564782464834" data-ad-slot="3630857048" data-ad-format="auto" data-full-width-responsive="true"></ins><script> (adsbygoogle = window.adsbygoogle || []).push({});</script>')
          : (advertisement =
              '<!-- Large rectangle side bar BL Tips AP --><ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-8656564782464834" data-ad-slot="7884445755" data-ad-format="auto" data-full-width-responsive="true"></ins><script> (adsbygoogle = window.adsbygoogle || []).push({});</script>');
        break;
    }
    return advertisement;
  };
}

export default new AdvertisementUtil();
